export type DiscountDisplaySource = {
  amount?: number | null;
  appliedAmount?: number | null;
};

export type AppliedDiscountSource = {
  amountCents?: number | null;
  squareExternalDiscountId?: string | null;
};

export const getDiscountDisplayAmountCents = (
  discount: DiscountDisplaySource,
  appliedLineItemAmountCents?: number | null
): number =>
  discount.appliedAmount ?? discount.amount ?? appliedLineItemAmountCents ?? 0;

export const getMatchingAppliedDiscountCents = (
  squareExternalId: string | null | undefined,
  lineItems: ReadonlyArray<
    | {
        appliedDiscounts?: ReadonlyArray<
          AppliedDiscountSource | null | undefined
        > | null;
      }
    | null
    | undefined
  >
): number | null => {
  if (!squareExternalId) {
    return null;
  }

  const matchingAmounts = lineItems.flatMap((lineItem) =>
    (lineItem?.appliedDiscounts ?? []).flatMap((appliedDiscount) =>
      appliedDiscount?.squareExternalDiscountId === squareExternalId &&
      appliedDiscount.amountCents != null
        ? [appliedDiscount.amountCents]
        : []
    )
  );

  if (matchingAmounts.length === 0) {
    return null;
  }

  return matchingAmounts.reduce((sum, amount) => sum + amount, 0);
};
